import React from 'react';


export const interests = [
    {
      interests: [
        {
          name: 'Python',
        },
        {
            name: 'C++',
        },
        {
            name: 'Java',
        },
        {
            name: 'MongoDB',
        },
        {
            name: 'Ruby',
        },
        
        
       
      ],
    }

  ];



  export const gutypes = [
    {
      gutypes: [
        {
          name: 'Diploma',
        },
        {
            name: 'Technical',
        },
        {
            name: 'Non-Technical',
        }
       
      ],
    }

  ];


  export const sessions = [
   
        {
          name: 'interactive Session with Python',
          icon: <img src="https://i.ibb.co/FDhZMJr/python.png" alt="python" border="0"></img>,
        },
        {
          name: 'Business Logic',
          icon: <img src="https://i.ibb.co/JjQnRbd/Business-Logic.png" alt="Business-Logic" border="0"></img>,
        },
        {
          name: 'UX Designing',
          icon: <img src="https://i.ibb.co/n3cqLpT/UXDesigning.png" alt="UXDesigning" border="0"></img>,
        },
        {
          name: 'interactive Session with Python',
          icon: <img src="https://i.ibb.co/FDhZMJr/python.png" alt="python" border="0"></img>,
        },
        {
          name: 'Business Logic',
          icon: <img src="https://i.ibb.co/JjQnRbd/Business-Logic.png" alt="Business-Logic" border="0"></img>,
        },
        {
          name: 'UX Designing',
          icon: <img src="https://i.ibb.co/n3cqLpT/UXDesigning.png" alt="UXDesigning" border="0"></img>,
        },
  
  ];
  

  export const badges = [
    {
      badges: [
        
        
        {
          name: 'Free Bird',
          icon: <img src="https://i.ibb.co/crFgY9m/Bird-Badge.png" alt="freeBird" border="0"></img>,
        },
        {
          name: 'Shield',
          icon: <img src="https://i.ibb.co/xYNFDJv/Shield-logo.png" alt="shield" border="0"></img>,
        },
       
      ],
    },
  
  ];
  